export default __webpack_public_path__ + "assets/images/cf7615abb2711cbec95d33f603ac0160.svg";